module.exports = __webpack_public_path__ + "../../../static/img/se_04.08d772b9.png";